<template>
    <div data-cy="container_mission_transaction">
        <div v-if="isComingSoon" data-cy="container_mission_transaction_coming_soon">
            <div class="flex flex-col my-auto justify-center items-center mt-20">
                <div class="text-16 text-center text-white pb-4">
                    {{ lbl.mission.mission_comingsoon }}
                </div>
                <div>
                    <img class="w-16" :src="imgUrl()" />
                </div>
            </div>
        </div>
        <div v-else class="relative mt-8">
            <MissionTransaction data-cy="list_mission_transaction" :transactionList="transactionList"></MissionTransaction>
        </div>
        <div class="pt-12">
            <div class="scroll-overlay w-full max-w-500 fixed bottom-0 left-0 right-0 py-2 mx-auto" v-if="!isBottom && !isComingSoon">
                <div class="absolute left-0 right-0 bottom-28 flex justify-center align-middle text-14 text-a-white-ffffff">
                    {{ lbl.mission.scroll_down }} <img class="pl-1" src="@/assets/icon/ic-scroll-down.svg" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
//component
import MissionTransaction from './MissionTransaction.vue'
//service
import MissionService from '@/module/Mission/service/MissionService.js';
import ConfigManager from '@/config/ConfigManager.js';
export default {
    name: "Transaction",
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin],
    components: {
        MissionTransaction
    },
    data: function() {
        return {
            transactionList: null,

            isBottom: false,
            isComingSoon: false,
        }
    },
    created: async function() {
        this.modal.loadingModal.show();
        this.transactionList = await this.getMissionTransaction();
        this.modal.loadingModal.hide();
        if (this.transactionList.length == 0) {
            this.isComingSoon = true;
            this.$emit('ComingSoon', this.isComingSoon);
        } else {
            this.isComingSoon = false;
            this.$emit('ComingSoon', this.isComingSoon);
        }
        this.setScrollDown();
    },
    beforeUnmount: function() {
        window.onscroll = null;
    },
    methods: {
        getMissionTransaction: function() {
            this.modal.loadingModal.show();
            return new Promise((resolve) => {
                MissionService.getMissionTrasaction()
                    .subscribe({
                        next: (res) => {
                            this.modal.loadingModal.hide();

                            let data = res.data.sort((a, b) => parseInt(a.Id) - parseInt(b.Id));
                            
                            resolve(data);
                        },
                        error: (err) => {
                            this.errorApi(err);
                            console.log(err);
                            this.modal.loadingModal.hide();
                            resolve(null);
                        }
                    });
            });
        },
        setScrollDown: function() {
            window.onscroll = () => {
                const clientHeight = document.documentElement.clientHeight;
                const scrollHeight = document.documentElement.scrollHeight;
                const scrollTop = document.documentElement.scrollTop;

                if (scrollTop + clientHeight >= scrollHeight-58) {
                    this.isBottom = true;
                }else{
                    this.isBottom = false;
                }
            };
        },
        imgUrl: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/mission/img-coming-soon.png`;
        },
    }

}
</script>
<style lang="scss" scoped>
.scroll-overlay{
    height: 160px;
    background-image: linear-gradient(to top, #000, rgba(84, 84, 84, 0));
}
</style>
